import React from "react";

import svg from "../../assets/images/icons/download_blue.svg";

export const DownloadBlueIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Download"}
    />
);
